export const calendarConstants = {
  GET_CALENDAR_EVENTS_REQUEST: 'GET_CALENDAR_EVENTS_REQUEST',
  GET_CALENDAR_EVENTS_SUCCESS: 'GET_CALENDAR_EVENTS_SUCCESS',
  GET_CALENDAR_EVENTS_FAILURE: 'GET_CALENDAR_EVENTS_FAILURE',

  UPDATE_RSVP_DATA: 'CALENDAR/UPDATE_RSVP_DATA',

  SET_SELECTED_EVENT: 'CALENDAR/SET_SELECTED_EVENT',

  SET_SELECTED_TAB: 'CALENDAR/SET_SELECTED_TAB'
}
